import { useMemo, useEffect } from 'react';
import { APPMETRICA_ORGANIC_URL, APPMETRICA_UTM_URL } from '../../../constants/appStoreLinks';

/**
 * Хук для работы с UTM-параметрами и ссылками AppMetrica
 */
const useAppMetricaLinks = () => {
    useEffect(() => {
        // Сохраняем UTM-параметры при загрузке страницы
        const currentUrl = new URL(window.location.href);
        const params = new URLSearchParams(currentUrl.search);
        const storedParams = sessionStorage.getItem("utmParams") || "";
        const utmParams = new URLSearchParams(storedParams);

        let hasUtmParams = false;

        for (const param of ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]) {
            if (params.get(param)) {
                utmParams.set(param, params.get(param));
                hasUtmParams = true;
            }
        }

        if (hasUtmParams) {
            sessionStorage.setItem("utmParams", utmParams.toString());
        }
    }, []);

    const appStoreUrl = useMemo(() => {
        const storedUtmParams = sessionStorage.getItem("utmParams");

        if (storedUtmParams) {
            // Если есть UTM-параметры, используем ссылку для UTM и добавляем параметры
            return `${APPMETRICA_UTM_URL}?${storedUtmParams}`;
        }

        // Если нет UTM-параметров, используем органическую ссылку
        return APPMETRICA_ORGANIC_URL;
    }, []);

    return {
        appStoreUrl,
        hasUtmParams: !!sessionStorage.getItem("utmParams")
    };
};

export default useAppMetricaLinks;